/* RK Bespoke Creations - scroll-scrubbed film with per-jewel HOLD bands.
   Maps scroll progress through the tall .rk-film track to video.currentTime via a piecewise curve:
   an intro scrub to beat 1, then for each jewel a flat HOLD (the film pauses on that frame while
   the jewel's popup is shown) followed by a scrub to the next beat. The video is paused and only
   seeked (all-keyframe encode => each seek is one decode). A high-res static hero shows at the top
   and fades on first scroll. Skipped under reduced motion (static hero stays). rAF-throttled. */
(function () {
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function isPhone() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }
  function saveData() {
    var c = navigator.connection;
    return !!(c && c.saveData);
  }
  function clamp01(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }

  /* Phone: no scrubbing. The film plays as a portrait loop in a single stage and the
     jewel panels are ordinary stacked cards (see rk-bespoke-film.css). Under Save-Data
     or reduced motion the poster/hero still frame is the final state and no video is
     fetched at all. */
  function setupPhone(root) {
    var video = root.querySelector('[data-rk-film-video]');
    var hero = root.querySelector('[data-rk-film-hero]');
    var mobileHero = hero && hero.getAttribute('data-mobile-src');
    if (mobileHero) hero.src = mobileHero;

    if (!video) return;
    if (saveData() || reduceMotion()) return; /* nothing fetched; hero still frame stays */

    /* Prefer the portrait cut; fall back to the desktop master only if none exists. */
    var src = video.getAttribute('data-mobile-src') || video.getAttribute('data-desktop-src');
    if (!src) return;
    video.preload = 'metadata';
    video.src = src;
    video.loop = true;
    video.muted = true;
    video.setAttribute('loop', '');

    /* Only spend battery and data while the film is on screen. */
    function play() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) play();
          else video.pause();
        });
      }, { threshold: 0.15 }).observe(video);
    } else {
      play();
    }
    /* Fade the static hero once the film has real frames to show. */
    video.addEventListener('playing', function () { root.classList.add('is-scrolled'); }, { once: true });
  }

  function setup(root) {
    if (!root || root.dataset.rkFilmReady === '1') return;
    root.dataset.rkFilmReady = '1';

    var video = root.querySelector('[data-rk-film-video]');
    var hero = root.querySelector('[data-rk-film-hero]');
    var popups = Array.prototype.slice.call(root.querySelectorAll('[data-rk-film-popup]')).map(function (el) {
      return { el: el, beat: parseFloat(el.getAttribute('data-beat')) || 0 };
    }).sort(function (a, b) { return a.beat - b.beat; });

    if (isPhone()) { setupPhone(root); return; }
    if (reduceMotion() || !video) return; /* static hero stays */

    /* The markup ships no src (see the section comment), so choose it here. Scrubbing
       needs the all-intra desktop encode: every seek must decode one frame only. */
    /* Desktop STREAMS the film from the Shopify CDN, which serves byte ranges (206), so the
       first frame decodes in under a second and any position can be seeked while the rest of
       the file downloads in the background. It starts at setup: on this page the film IS the
       content. (Until 2026-10-12 the whole 9.6 MB file was fetched as a blob BEFORE playback,
       which froze the scrub on the opening still for ~7.6 s on a normal connection while the
       visitor kept scrolling.) The blob path below survives only as the fallback for servers
       without byte ranges, i.e. `shopify theme dev` (see ensureSeekable). The static hero
       covers the stage until the first real frame is decoded (see `framed` below). */
    var duration = 0, blobTried = false, framed = false;
    video.removeAttribute('poster'); /* the poster is the PHONE still; on desktop it flashed in the gap */
    if (saveData()) return; /* Save-Data: keep the static hero, never fetch the 9.5 MB film */
    var desktopSrc = video.getAttribute('data-desktop-src');
    if (desktopSrc && !video.getAttribute('src')) {
      video.preload = 'auto';
      video.src = desktopSrc;
    }

    function readMeta() { duration = isFinite(video.duration) ? video.duration : 0; }
    /* `framed` = the film has decoded a frame at a scrubbed position; until then the
       static hero stays on top so nothing (frame 0, a poster, a black canvas) can flash. */
    var pendingT = -1;
    video.addEventListener('seeked', function () {
      framed = true;
      if (pendingT >= 0 && Math.abs(video.currentTime - pendingT) > 0.012) { var n = pendingT; pendingT = -1; try { video.currentTime = n; } catch (e) {} }
      else { pendingT = -1; }
      apply();
    });
    if (video.readyState >= 1) readMeta();
    video.addEventListener('loadedmetadata', function () { readMeta(); apply(); });
    video.addEventListener('loadeddata', function () { readMeta(); ensureSeekable(); apply(); });

    /* Browsers only allow seeking into media served with HTTP byte ranges. The Shopify CDN
       sends 206 Partial Content and scrubbing works; `shopify theme dev` proxies assets as
       a single 200 with no Accept-Ranges, so Chrome reports seekable = [0,0] and silently
       ignores every currentTime write: the film sits frozen on frame 0 all the way down.
       When that happens, pull the file once into memory and play it from a blob URL, which
       is always fully seekable. On the CDN this branch never runs. */
    /* The seekable range is not final on loadedmetadata/loadeddata (Chrome reports it a
       beat later), so poll briefly instead of trusting a single event. */
    var seekPolls = 0;
    var seekTimer = setInterval(function () {
      seekPolls++;
      if (!duration) readMeta();
      if (duration) ensureSeekable();
      if (blobTried || seekPolls > 40) clearInterval(seekTimer);
      else if (duration) { var e = 0; try { if (video.seekable.length) e = video.seekable.end(video.seekable.length - 1); } catch (x) {} if (e > duration - 0.5) clearInterval(seekTimer); }
    }, 250);
    function ensureSeekable() {
      if (blobTried || !duration) return;
      var end = 0;
      try { if (video.seekable && video.seekable.length) end = video.seekable.end(video.seekable.length - 1); } catch (e) {}
      if (end > duration - 0.5) return; /* healthy: whole film is seekable */
      blobTried = true;
      if (!window.fetch || !window.URL || !URL.createObjectURL) return;
      /* Distinct URL on purpose: Chrome holds the media element's own connection open and
         queues a second request for the identical URL behind it (measured ~20s stall). */
      var src = video.currentSrc || video.src;
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'rkblob=1';
      fetch(src, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.blob() : null; }).then(function (blob) {
        if (!blob) return;
        video.src = URL.createObjectURL(blob);
        video.addEventListener('loadeddata', function () { readMeta(); apply(); }, { once: true });
      }).catch(function () {});
    }
    video.pause();
    video.addEventListener('play', function () { video.pause(); });

    /* zone map: intro scrub -> [hold, scrub] per jewel (last jewel has no trailing scrub) */
    var SCRUB = 0.95, HOLD = 1.4, INTRO = 1.0;
    var zones = [];
    if (popups.length) {
      zones.push({ type: 'scrub', from: 0, to: popups[0].beat, w: INTRO });
      for (var i = 0; i < popups.length; i++) {
        zones.push({ type: 'hold', time: popups[i].beat, popup: i, w: HOLD });
        if (i < popups.length - 1) zones.push({ type: 'scrub', from: popups[i].beat, to: popups[i + 1].beat, w: SCRUB });
      }
    } else {
      zones.push({ type: 'scrub', from: 0, to: -1, w: 1 }); /* -1 = use full duration */
    }
    var totalW = 0, k;
    for (k = 0; k < zones.length; k++) totalW += zones[k].w;
    var acc = 0;
    for (k = 0; k < zones.length; k++) { zones[k].start = acc / totalW; acc += zones[k].w; zones[k].end = acc / totalW; }

    function progress() {
      var total = root.offsetHeight - window.innerHeight;
      if (total <= 0) return 0;
      return clamp01(-root.getBoundingClientRect().top / total);
    }

    var ticking = false, activePopup = -2;
    function apply() {
      ticking = false;
      var p = progress();
      /* Once the film has shown its first scrubbed frame the hero stays down for good while
         scrolled; re-checking `seeking` here made it flicker back in between seeks. */
      if (hero) root.classList.toggle('is-scrolled', p > 0.004 && framed);
      if (!duration) return;

      var z = zones[zones.length - 1];
      for (var i = 0; i < zones.length; i++) { if (p <= zones[i].end) { z = zones[i]; break; } }
      var span = (z.end - z.start) || 1;
      var lt = clamp01((p - z.start) / span);

      var t, want = -1;
      if (z.type === 'scrub') {
        if (z.to < 0) { t = lt * duration; }
        else { t = z.from + (z.to - z.from) * lt; }
      } else {
        t = z.time; want = z.popup;
      }
      if (t > duration - 0.04) t = duration - 0.04;
      if (t < 0) t = 0;
      /* Serialise seeks: while one frame is still decoding, remember the newest target and
         issue it from `seeked`. Firing a seek per scroll event piles decodes up and Chrome
         drops frames (a visible blink) right before a hold, where the target stops moving. */
      if (Math.abs(video.currentTime - t) > 0.012) {
        if (video.seeking) { pendingT = t; }
        else { pendingT = -1; try { video.currentTime = t; } catch (e) {} }
      }

      if (want !== activePopup) {
        activePopup = want;
        for (var j = 0; j < popups.length; j++) popups[j].el.classList.toggle('is-active', j === want);
      }
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(apply); } }

    /* No video.load() call anywhere: setting .src above already starts the stream,
       and load() used to restart it, pulling the whole 9.5MB film twice. */
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', apply);
    apply();
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-rk-film]')).forEach(setup);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-rk-film]') : null;
    if (root) {
      var v = root.querySelector('[data-rk-film-video]');
      if (v && /^blob:/.test(v.src)) { try { URL.revokeObjectURL(v.src); } catch (x) {} v.removeAttribute('src'); }
      root.dataset.rkFilmReady = ''; setup(root);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
